/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Supplier_TotalsInputs */

const en_nav_supplier_totals = /** @type {(inputs: Nav_Supplier_TotalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`POs by supplier`)
};

/**
* | output |
* | --- |
* | "POs by supplier" |
*
* @param {Nav_Supplier_TotalsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_supplier_totals = /** @type {((inputs?: Nav_Supplier_TotalsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Supplier_TotalsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_supplier_totals(inputs)
});